<template lang="pug">
form-radio-group
  slot
</template>

<script>
customElements.define(
  'form-radio-group',
  class extends HTMLElement {
    constructor() {
      super();
    }
  }
);

export default {
  name: 'Group',
};
</script>

<style lang="scss" scoped>
form-radio-group {
  @include radio-group;
}
</style>
